import { useState } from 'react';

export const useConfirmationError = () => {
  const [confirmationError, setConfirmationError] = useState('');

  const addConfirmationError = (error: string) => setConfirmationError(error);
  const resetConfirmationError = () => setConfirmationError('');

  return { confirmationError, addConfirmationError, resetConfirmationError };
};
